export default function isDecimal(num?: number) {
  if ([undefined, null, NaN].includes(num)) return false

  return (num || 0) % 1 !== 0
}
